<img class="mt-avatar" [ngClass]="type" [src]="imgSrc" alt="" />
